import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.jsx';
import CarouselSection from '../../../../../../components/Projects/CarouselSection/CarouselSection.jsx';

class SectionD extends Component{

    render(){

        const {classes, content} = this.props;

        return(
            <div className={classes.section}>
                <div className={classes.container}>
                    <CarouselSection 
                        title={content.title} 
                        {...content}
                    />
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(SectionD);